"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var eosjs_1 = require("eosjs");
var ecc = __importStar(require("eosjs-ecc"));
var link_abi_data_1 = __importDefault(require("./link-abi-data"));
var types = eosjs_1.Serialize.getTypesFromAbi(eosjs_1.Serialize.createInitialTypes(), link_abi_data_1.default);
function abiEncode(value, typeName) {
    var type = types.get(typeName);
    if (!type) {
        throw new Error("No such type: " + typeName);
    }
    var buf = new eosjs_1.Serialize.SerialBuffer();
    type.serialize(buf, value);
    return buf.asUint8Array();
}
exports.abiEncode = abiEncode;
function abiDecode(data, typeName) {
    var type = types.get(typeName);
    if (!type) {
        throw new Error("No such type: " + typeName);
    }
    if (typeof data === 'string') {
        data = eosjs_1.Serialize.hexToUint8Array(data);
    }
    else if (!(data instanceof Uint8Array)) {
        data = new Uint8Array(data);
    }
    var buf = new eosjs_1.Serialize.SerialBuffer({
        array: data,
    });
    return type.deserialize(buf);
}
exports.abiDecode = abiDecode;
function sealMessage(message, privateKey, publicKey) {
    var res = ecc.Aes.encrypt(privateKey, publicKey, message);
    var data = {
        from: ecc.privateToPublic(privateKey),
        nonce: res.nonce.toString(),
        ciphertext: res.message,
        checksum: res.checksum,
    };
    return abiEncode(data, 'sealed_message');
}
exports.sealMessage = sealMessage;
//# sourceMappingURL=utils.js.map